import React from 'react'
import { Fragment } from 'react'
import { NavLink } from 'react-router-dom'
import Navbar from '../../component/Other/Navbar'
import Contact from '../../component/Page/Contact'
import Footer from '../../component/Page/Footer'
import Portofolio from '../../component/Page/Portofolio'
import Seen from '../../component/Page/Seen'
import Testimonial from '../../component/Page/Testimonial'
import SecAcout from "./../../component/Page/About"

const About = () => {
    const team = [
        {
            img: "./../images/av (7).png",
            name: "Nolan Korsgaard",
            title: "Founder & Owners"
        },
        {
            img: "./../images/av (8).png",
            name: "Jaylon Vaccaro",
            title: "Founder & Owners"
        },
        {
            img: "./../images/av (1).png",
            name: "Ryan Gouse",
            title: "Founder & Owners"
        },
        {
            img: "./../images/av (6).png",
            name: "Cooper Saris",
            title: "Founder & Owners"
        },
    ]
    return (
        <Fragment>
            <div className="overflow-hidden">
                <Navbar type={"dark"} />

                <SecAcout />

                <section>
                    <div className="container">
                        <div className="row text-center">
                            <div className="col-6 col-lg-3 mb-4 my-lg-auto">
                                <h3 className='semi-bold font__size--64 text__65-1024 text__65-sm play color__brown'>1.356</h3>
                                <p className='normal font__size--18 text__18-1024 text-uppercase'>DIFFERENT VENUE</p>
                            </div>
                            <div className="col-6 col-lg-3 mb-4 my-lg-auto">
                                <h3 className='semi-bold font__size--64 text__65-1024 text__65-sm play color__brown'>4.356</h3>
                                <p className='normal font__size--18 text__18-1024 text-uppercase'>CLIENT SATISFIED</p>
                            </div>
                            <div className="col-6 col-lg-3 mb-4 my-lg-auto">
                                <h3 className='semi-bold font__size--64 text__65-1024 text__65-sm play color__brown'>4.356</h3>
                                <p className='normal font__size--18 text__18-1024 text-uppercase'>CLIENT SATISFIED</p>
                            </div>
                            <div className="col-6 col-lg-3 mb-4 my-lg-auto">
                                <h3 className='semi-bold font__size--64 text__65-1024 text__65-sm play color__brown'>+254</h3>
                                <p className='normal font__size--18 text__18-1024 text-uppercase'>Brand partner</p>
                            </div>
                        </div>
                    </div>
                </section>

                <Portofolio />

                <Seen />

                <section>
                    <div className="container">
                        <div className="mb-5 text-center">
                            <h2 className="medium font__size--48 text__48-1024 text__48-md text__48-sm text__48-xx play">Meet Our Team</h2>
                            <div className="d-flex align-items-center justify-content-center normal font__size--24 text__24-1024 text-capitalize color__brown mt-3">
                                <img src="./../images/Vector 2.png" alt="" />
                                <span className="mx-3">our team</span>
                                <img src="./../images/Vector 1.png" alt="" />
                            </div>
                        </div>

                        <div className="row mb-5">
                            {
                                team.map((obj) => {
                                    return <div className="wrapper__pd-wrap col-6 mb-4 mb-lg-0 col-lg-3">
                                        <div className="wrapper__card-team text-center">
                                            <img src={obj.img} className='profile' alt="" />

                                            <div className="my-3">
                                                <h4 className='medium font__size--20 text__20-1024 play'>{obj.name}</h4>
                                                <p className='normal font__size--14 text__14-1024 color__gray-1'>{obj.title}</p>
                                            </div>

                                            <div className="sosmed">
                                                <a href="#!">
                                                    <img src="./../images/soss (3).png" alt="" />
                                                </a>
                                                <a href="#!">
                                                    <img src="./../images/soss (1).png" alt="" />
                                                </a>
                                                <a href="#!">
                                                    <img src="./../images/soss (2).png" alt="" />
                                                </a>
                                            </div>
                                        </div>
                                    </div>
                                })
                            }
                        </div>


                        <div className="text-center">
                            <NavLink to="/team" className="medium font__size--14 text__14-1024 btn btn__outlined--darkgreen color__darkgreen shadow text-capitalize rounded__50 h__white no__opacity pointer" >See All Team</NavLink>
                        </div>
                    </div>
                </section>

                <Testimonial />

                <Contact />

                <Footer />
            </div >
        </Fragment >
    )
}

export default About